export enum OnboardingType {
  PIPELINES = 'pipelines',
  DEPLOYMENTS = 'deployments',
}
